module.exports = __webpack_public_path__ + "static/media/pokemonGame.c6e1f340.png";